import { takeLatest, call, put } from 'redux-saga/effects';

import { submitRegisterForm } from './api';
import { fetchRegisterFormSubmissionSuccess, fetchRegisterFormSubmissionFail } from './actions';
import generalActionTypes from './action-types';

function* fetchRegisterFormSubmissionSaga({ payload }) {
  const { callbackActionSuccess, callbackActionFail } = payload;

  try {
    const response = yield call(submitRegisterForm, payload);
    callbackActionSuccess();
    yield put(fetchRegisterFormSubmissionSuccess(response.data.Cities));
  } catch (error) {
    callbackActionFail();
    yield put(fetchRegisterFormSubmissionFail(error));
  }
}

function* generalSaga() {
  yield takeLatest(
    generalActionTypes.FETCH_REGISTER_FORM_SUBMISSION,
    fetchRegisterFormSubmissionSaga,
  );
}

export default generalSaga;
